import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { StorageManager } from "@/features/admin/components/storage-manager";
import { PageContainer } from "@fleet/ui";

function AdminStoragePage() {
  return (
    <PageContainer maxWidth="5xl">
      <StorageManager />
    </PageContainer>
  );
}

/** Deep-linkable S3 object filter: `?filter=all|linked|orphaned`. */
export interface AdminStorageSearch {
  filter?: "all" | "linked" | "orphaned";
}

// `all` is represented by the absence of the parameter (clean URL), so it is
// not stored as an explicit value.
const STORAGE_FILTERS = ["linked", "orphaned"] as const;

function parseStorageFilter(value: unknown): AdminStorageSearch["filter"] {
  return STORAGE_FILTERS.find((f) => f === value);
}

export const adminStorageRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/storage",
  component: AdminStoragePage,
  validateSearch: (search: Record<string, unknown>): AdminStorageSearch => ({
    filter: parseStorageFilter(search.filter),
  }),
});
